module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"converterEvaluationError":"Error calculating datapoint"},"de":{"converterEvaluationError":"Fehler bei der Berechnung des Datenpunkts"},"fr":{"converterEvaluationError":"Erreur de calcul du point de données"},"it":{"converterEvaluationError":"Errore nel calcolo del punto dati"}}')
  delete Component.options._Ctor
}
